import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { type NextBestAction } from '@post-office/confluence-next-best-action';

import { PlacementFrontend } from '@post-office/browser--growth/confluence-side-nav';

import { ResurrectedUserWelcomeMessage } from './message';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

import { type MessageTemplateContext } from '../../../index';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type MessageFrontendProps = MessageTemplateContext & {
	onSideNavClick: (nextBestActionType: NextBestAction) => string | void | null;
	handleOnDismissed: () => void;
};

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({
			nextBestActionType,
			onSideNavClick,
			handleOnDismissed,
		}: MessageFrontendProps) => {
			return (
				<ResurrectedUserWelcomeMessage
					onSideNavClick={onSideNavClick}
					handleOnDismissed={handleOnDismissed}
					nextBestActionType={nextBestActionType}
				/>
			);
		},
	},
});
